export const SELECTORS = {
  OTP_DISCOUNT: 'js-otp-discount'
};
